import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as classes from './CartDrawer.module.css';
import CloseIcon from '../../assets/icons/inline/close.svg';
import Button from '../button/Button.js';
import { useCart, useCheckout } from '../../context/shopContext';
import useLocalisation from '../../hooks/useLocalisation';
import { Link } from 'gatsby';

const CartDrawer = ({ setCartDrawerOpen, language = 'fi' }) => {
  const { localize, toLocalisationKey } = useLocalisation(language);
  const [lineItems, setLineItems] = useState([]);
  const [checkedTerms, setCheckedTerms] = useState(false);
  const checkout = useCheckout();
  const { emptyCart, updateNote } = useCart();

  useEffect(() => {
    setLineItems(checkout.lineItems);
  }, [checkout.lineItems]);

  const goToCheckout = async () => {
    await updateNote(language);
    window.location.href = `${checkout.webUrl}&locale=${language}`;
  };

  const getEventInfo = (item) => {
    try {
      const json = JSON.parse(item.customAttributes[0].value);
      return json.time;
    } catch (e) {
      console.error(e);
      return '';
    }
  };

  return (
    <div className={classes.cartDrawer}>
      <div className={classes.cartDrawerHeader}>
        <h3>{localize('ORDER_SUMMARY')}</h3>
        <button
          className={classes.cartCloseButton}
          onClick={() => setCartDrawerOpen(false)}
        >
          <img src={CloseIcon} alt="close cart icon" />
        </button>
      </div>
      <div className={classes.productSection}>
        <ul>
          {checkout &&
            checkout.lineItems.map((item) => (
              <li key={item.id}>
                <p style={{ flex: 1, display: 'flex', flexFlow: 'column' }}>
                  <span>{item.title}</span>
                  <span style={{ fontSize: '.8rem' }}>
                    {getEventInfo(item)}
                  </span>
                </p>
                <p>x {item.quantity}</p>
              </li>
            ))}
        </ul>
      </div>
      <div className={classes.priceSection}>
        <div className={classes.priceTitle}>
          <h4>{localize('TOTAL_PRICE')}</h4>
        </div>
        <div className={classes.priceQuantity}>
          <h4>{parseFloat(checkout.totalPrice.amount)} €</h4>
        </div>
      </div>
      {lineItems.length ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button onClick={emptyCart}>{localize('REMOVE_ORDER')}</Button>
        </div>
      ) : null}
      <div className={classes.cartDrawerFooter}>
        <div className={classes.disclaimer}>
          <input
            type="checkbox"
            name="terms-checkbox"
            value="terms-checkbox"
            className={classes.checkbox}
            id="terms-checkbox"
            onChange={() => {}}
          />
          <span
            className={`${classes.checkboxSubstitute} ${
              checkedTerms ? classes.checked : ''
            }`}
            onClick={() => setCheckedTerms(!checkedTerms)}
          />
          <span className={classes.checkboxLabel}>
            {localize('ACCEPT')}
            <Link
              to={
                language === 'fi'
                  ? '/fi/osto-ja-varausehdot/'
                  : '/terms-and-conditions/'
              }
            >
              {` ${localize('TERMS_AND_CONDITIONS', '')}`}
            </Link>
          </span>
        </div>
        <div className={classes.buttonSection}>
          <Button
            disabled={!checkedTerms || !lineItems.length}
            primary
            children={localize('CHECKOUT')}
            onClick={goToCheckout}
          />
        </div>
      </div>
    </div>
  );
};

CartDrawer.propTypes = {
  setCartDrawerOpen: PropTypes.func.isRequired,
};

export default CartDrawer;
